module.exports = {
	"LANGUAGE": "言語",
	"HDR-obpa_fulltext_score": "スコア",
	"HDR-obpa_name": "名前",
	"HDR-obpa_fulltext_summary": "一覧",
	"QUERY LIMIT REACHED": "表示されているものよりも多くの結果があります。検索条件を絞り込んでください。",
	"NO DOCUMENTS FOUND": "ドキュメントが見つかりません。",
	"OPEN IN NEW WINDOW": "新しいウィンドウで開く",
	"DOWNLOAD NATIVE": "ネイティブフォーマットでダウンロード",
	"CLOSE": "閉じる",
	"SEARCH TYPE": "検索タイプ",
	"DOCUMENT TYPE": "ドキュメントタイプ",
	"SEARCH TERM": "検索項目",
	"SEARCH": "検索",
	"RESET": "リセット",
	"DATE": "日付",
	"FROM DATE": "開始日",
	"TO DATE": "終了日",
	"LOADING": "ロード中...",
	"RETRY": "再試行",
	"ERROR": "エラー!",
	"ERROR: QUERIES": "検索タイプのリストを取得できません。",
	"ERROR: DOCTYPES": "文書タイプのリストを取得できません。",
	"ERROR: KEYWORDS": "検索フィールドのリストを取得できません。",
	"ERROR: DOCUMENTS": "要求された検索を実行できません。",
	"FORM: INVALID FULLTEXT": "フィールドは {{chars}} 文字以上でなければなりません。",
	"FORM: INVALID DATE SHORT": "フォーマット: {{format}} .",
	"FORM: REQUIRED KEYWORD": "フィールドが必要です。",
	"FORM: INVALID NUMERIC": "フィールドは最大 {{digits}} 桁の数字でなければなりません。",
	"FORM: INVALID DATE": "フィールドはフォーマットに従う必要があります {{format}} .",
	"FORM: INVALID CURRENCY": "フィールドは有効な通貨値でなければなりません。",
	"FORM: INVALID FLOAT": "フィールドは数字でなければなりません。",
	"FORM: INVALID LENGTH": "フィールドは最大 {{chars}} 文字でなければなりません。",
	"FORM: ERRORS": "フォームにエラーがあります。",
	"FORM: noDate": "日付範囲を指定する必要があります。",
	"FORM: noKeyword": "少なくとも1つのフィールドを指定しなければなりません。",
	"FORM: noDateOrKeyword": "日付範囲または少なくとも1つのフィールドを指定する必要があります。",
	"FORM: noDateAndKeyword": "日付範囲AND少なくとも1つのフィールドを指定する必要があります。"
};


//////////////////
// WEBPACK FOOTER
// ./src/app/shared/i18n/json/ja.json
// module id = 356
// module chunks = 0